/* eslint-disable max-statements */
import { BatchTypeEnum, Report, ReportStatus, ReportTypes } from '@e-origin/shared';

export const STATUS_MESSAGES = {
  [ReportStatus.IN_PROGRESS]: 'is being generated.',
  [ReportStatus.FAILED]: 'generation failed. Please try again or contact support.',
  [ReportStatus.DONE]: 'is ready to download.',
} as const;

export const getReportMessage = (report: Report, isNL: boolean): { prefix: string; value: string } => {
  switch (report.payload.reportType) {
    case ReportTypes.BATCH_REPORT:
      return {
        prefix: 'Customs report for batch',
        value: report.payload[ReportTypes.BATCH_REPORT].batchName || '',
      };
    case ReportTypes.DAILY:
      return {
        prefix: 'Daily report for',
        value: report.payload[ReportTypes.DAILY].date || '',
      };
    case ReportTypes.EXPORT_WITH_RISK_ANALYSIS:
      return {
        prefix: 'Export with risk analysis report',
        value: report.payload[ReportTypes.EXPORT_WITH_RISK_ANALYSIS].batchName || '',
      };
    case ReportTypes.INTERVAT: {
      const { quarter, month, year } = report.payload[ReportTypes.INTERVAT];
      const dateStr = quarter ? `Q${quarter}/${year}` : `${month}/${year}`;
      return {
        prefix: 'Intervat report for',
        value: dateStr,
      };
    }
    case ReportTypes.INTRACOM: {
      const { quarter, month, year } = report.payload[ReportTypes.INTRACOM];
      const dateStr = quarter ? `Q${quarter}/${year}` : `${month}/${year}`;
      return {
        prefix: 'Intracom report for',
        value: dateStr,
      };
    }
    case ReportTypes.INTRASTAT: {
      const { quarter, month, year } = report.payload[ReportTypes.INTRASTAT];
      const dateStr = quarter ? `Q${quarter}/${year}` : `${month}/${year}`;
      return {
        prefix: 'Intrastat report for',
        value: dateStr,
      };
    }
    case ReportTypes.INVOICE:
      return {
        prefix: 'Invoice for batch',
        value: report.payload[ReportTypes.INVOICE].batchName || '',
      };
    case ReportTypes.NCTS:
      return {
        prefix: 'Customs report for transit',
        value: report.payload[ReportTypes.NCTS].transitName || '',
      };

    case ReportTypes.NCTS_FOLLOW_LETTER:
      return {
        prefix: 'Follow letter for transit',
        value: report.payload[ReportTypes.NCTS_FOLLOW_LETTER].transitName || '',
      };

    case ReportTypes.RISK_ANALYSIS:
      return {
        prefix: 'Risk analysis report for batch',
        value: report.payload[ReportTypes.RISK_ANALYSIS].batchName || '',
      };
    case ReportTypes.SEND_RISK_ANALYSIS:
      return {
        prefix: 'Customer report for batch',
        value: report.payload[ReportTypes.SEND_RISK_ANALYSIS].batchName || '',
      };
    case ReportTypes.PROFORMA_B2B_INVOICE:
      return {
        prefix: 'Proforma B2B invoice for batch',
        value: report.payload[ReportTypes.PROFORMA_B2B_INVOICE].batchName || '',
      };
    case ReportTypes.CUSTOMS_REGISTER: {
      const { startDate, endDate, year, batchType, groupByShippingMarks } = report.payload[ReportTypes.CUSTOMS_REGISTER];
      const type = batchType === BatchTypeEnum.HIGH_VALUES ? 'HV' : batchType === BatchTypeEnum.LOW_VALUES ? 'LV' : 'Export';
      return {
        prefix: `${type} Customs register ${groupByShippingMarks ? 'grouped by shipping marks' : ''} report for`,
        value: year ?? `${startDate}-to-${endDate}`,
      };
    }
    case ReportTypes.CBAM_REPORT: {
      const { startDate, endDate, year } = report.payload[ReportTypes.CBAM_REPORT];
      return {
        prefix: 'CBAM report for',
        value: year ?? `${startDate}-to-${endDate}`,
      };
    }
    case ReportTypes.WRITE_OFF:
      return {
        prefix: 'Write off report for batch',
        value: report.payload[ReportTypes.WRITE_OFF].batchName || '',
      };
    case ReportTypes.UTB_REPORT:
      return {
        prefix: `${isNL ? 'UTB' : 'Customs Debt'} report for batch`,
        value: report.payload[ReportTypes.UTB_REPORT].batchName || '',
      };
    default:
      return {
        prefix: 'Unknown report type',
        value: '',
      };
  }
};
